var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpuLimiterTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CPU Limiter_ON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2 2.2666V7.0666L13.6 7.0666L13.6 2.2666L15.2 2.2666Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2 19.8666V24.6666H13.6L13.6 19.8666H15.2Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.6666H7.2V14.2666H0V12.6666Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8 12.6666H24V14.2666H16.8V12.6666Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 2.2666L10.4 7.0666L8.8 7.0666L8.80001 2.2666L10.4 2.2666Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 19.8666L10.4 24.6666H8.8L8.80001 19.8666H10.4Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5.4666H4V21.4666H20V5.4666ZM2.4 3.8666V23.0666H21.6V3.8666H2.4Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8 8.6666H7.2V18.2666H16.8V8.6666ZM5.6 7.0666V19.8666H18.4V7.0666H5.6Z",
    fill: "#FA1D4E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuLimiterTitle);
export default __webpack_public_path__ + "static/media/cpuLimiterTitle.f1fcbe7908ab06111bc319ed326a635a.svg";
export { ForwardRef as ReactComponent };